
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon192Frame = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 214,
  height: 214,
  viewBox: "0 0 214 214",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-61.9%",
  y: "-64.3%",
  width: "228.6%",
  height: "228.6%",
  filterUnits: "objectBoundingBox",
  id: "icon-192-frame_b4e0285a7ac4af52__a"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  x: "-61.9%",
  y: "-64.3%",
  width: "228.6%",
  height: "228.6%",
  filterUnits: "objectBoundingBox",
  id: "icon-192-frame_b4e0285a7ac4af52__b"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  x: "-61.9%",
  y: "-64.3%",
  width: "228.6%",
  height: "228.6%",
  filterUnits: "objectBoundingBox",
  id: "icon-192-frame_b4e0285a7ac4af52__c"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  x: "-61.9%",
  y: "-64.3%",
  width: "228.6%",
  height: "228.6%",
  filterUnits: "objectBoundingBox",
  id: "icon-192-frame_b4e0285a7ac4af52__d"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#icon-192-frame_b4e0285a7ac4af52__a)",
  transform: "translate(11 11)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 .5h20M1 .5v20"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#icon-192-frame_b4e0285a7ac4af52__b)",
  transform: "rotate(-90 107 96)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 .5h20M1 .5v20"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#icon-192-frame_b4e0285a7ac4af52__c)",
  transform: "rotate(90 96 107)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 .5h20M1 .5v20"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#icon-192-frame_b4e0285a7ac4af52__d)",
  transform: "rotate(-180 101.5 101.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 .5h20M1 .5v20"
})))));

      const __svgRaw = "<svg width=\"214\" height=\"214\" viewBox=\"0 0 214 214\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <defs>\r\n        <filter x=\"-61.9%\" y=\"-64.3%\" width=\"228.6%\" height=\"228.6%\" filterUnits=\"objectBoundingBox\" id=\"3eza6xloxa\">\r\n            <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"/>\r\n            <feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0\" in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\"/>\r\n            <feMerge>\r\n                <feMergeNode in=\"shadowMatrixOuter1\"/>\r\n                <feMergeNode in=\"SourceGraphic\"/>\r\n            </feMerge>\r\n        </filter>\r\n        <filter x=\"-61.9%\" y=\"-64.3%\" width=\"228.6%\" height=\"228.6%\" filterUnits=\"objectBoundingBox\" id=\"b0kmktfv7b\">\r\n            <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"/>\r\n            <feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0\" in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\"/>\r\n            <feMerge>\r\n                <feMergeNode in=\"shadowMatrixOuter1\"/>\r\n                <feMergeNode in=\"SourceGraphic\"/>\r\n            </feMerge>\r\n        </filter>\r\n        <filter x=\"-61.9%\" y=\"-64.3%\" width=\"228.6%\" height=\"228.6%\" filterUnits=\"objectBoundingBox\" id=\"tkulmht7lc\">\r\n            <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"/>\r\n            <feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0\" in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\"/>\r\n            <feMerge>\r\n                <feMergeNode in=\"shadowMatrixOuter1\"/>\r\n                <feMergeNode in=\"SourceGraphic\"/>\r\n            </feMerge>\r\n        </filter>\r\n        <filter x=\"-61.9%\" y=\"-64.3%\" width=\"228.6%\" height=\"228.6%\" filterUnits=\"objectBoundingBox\" id=\"gpp6wl113d\">\r\n            <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"/>\r\n            <feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0\" in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\"/>\r\n            <feMerge>\r\n                <feMergeNode in=\"shadowMatrixOuter1\"/>\r\n                <feMergeNode in=\"SourceGraphic\"/>\r\n            </feMerge>\r\n        </filter>\r\n    </defs>\r\n    <g stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n        <g filter=\"url(#3eza6xloxa)\" transform=\"translate(11 11)\">\r\n            <path d=\"M1 .5h20M1 .5v20\"/>\r\n        </g>\r\n        <g filter=\"url(#b0kmktfv7b)\" transform=\"rotate(-90 107 96)\">\r\n            <path d=\"M1 .5h20M1 .5v20\"/>\r\n        </g>\r\n        <g filter=\"url(#tkulmht7lc)\" transform=\"rotate(90 96 107)\">\r\n            <path d=\"M1 .5h20M1 .5v20\"/>\r\n        </g>\r\n        <g filter=\"url(#gpp6wl113d)\" transform=\"rotate(-180 101.5 101.5)\">\r\n            <path d=\"M1 .5h20M1 .5v20\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-192-frame.b4e0285a7ac4af5221f0c59ce2f9d7a4.svg"),
        {
          React: SvgIcon192Frame,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      